import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DryRunResult, SafeguardOverride, SafeguardRunHistory } from '../../models/sepa-safeguard';

@Injectable({
  providedIn: 'root'
})
export class SepaSafeguardService {
  protected baseUrl = 'json/sepa/safeguard';

  constructor(protected http: HttpClient) {}

  createOverride(reason: string): Observable<SafeguardOverride> {
    return this.http.post<SafeguardOverride>(`${this.baseUrl}/override`, { reason });
  }

  getActiveOverride(): Observable<SafeguardOverride | null> {
    return this.http.get<SafeguardOverride | null>(`${this.baseUrl}/override/active`);
  }

  getRunHistory(): Observable<SafeguardRunHistory[]> {
    return this.http.get<SafeguardRunHistory[]>(`${this.baseUrl}/history`);
  }

  dryRun(): Observable<DryRunResult> {
    return this.http.post<DryRunResult>(`${this.baseUrl}/dry-run`, {});
  }
}
